import client from '../axios/client';

const reportsApi = {
  // Listar todos os relatórios disponíveis
  listReports: async (limit = 50, offset = 0) => {
    const response = await client.get('/reports', {
      params: { limit, offset }
    });
    return response.data;
  },

  // Executar um relatório específico
  executeReport: async (reportId) => {
    const response = await client.post(`/reports/${reportId}/execute`);
    return response.data;
  }
};

export default reportsApi;
